import { usePetitionDetailsPageData } from 'src/app/pages/petitionGamma/details/pageContext';

import { useDecisionMakers } from '../../../../hooks/useDecisionMakers';
import type { BuildingBlockDms } from '../../../../shared/types';

type Result = ModelHookResult<{
	sortedAllDms: BuildingBlockDms;
	petitionAsk: string;
}>;

export function useViewAll(): Result {
	const {
		data: { sortedAllDms },
	} = useDecisionMakers();

	const {
		data: {
			petition: { ask },
		},
	} = usePetitionDetailsPageData();

	return {
		data: {
			petitionAsk: ask,
			sortedAllDms,
		},
	};
}
